export default {
  apiserver: "https://oldserver.abbilar.ir/dashboard",
  apiserverapp: "https://oldserver.abbilar.ir/app",
  server: "https://oldserver.abbilar.ir/",
  fileserver: "https://oldserver.abbilar.ir",
  publicserver: "https://oldserver.abbilar.ir",

  // apiserver: "http://localhost:1401/dashboard",
  // apiserverapp: "http://localhost:1401/app",
  // server: "http://localhost:1401/",
};
